module.exports = __webpack_public_path__ + "img/DevelopmentIcon.3afdcaf7.svg";